"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8537 15.1459c1.7878 1.7878 4.1511 3.0648 5.9849 3.8667 1.227.5365 2.6806.1958 3.7192-.8428l1.1086-1.1087-3.3672-2.2897-.6809.6809c-.4336.4337-1.1097.6959-1.8154.4933-.7847-.2253-2.2164-.7943-3.5855-2.1634-1.3691-1.3691-1.938-2.8008-2.1634-3.5855-.2026-.7057.0596-1.3818.4933-1.8155l.6809-.6808-2.2897-3.3672-1.1087 1.1086C4.7912 6.4804 4.4505 7.934 4.987 9.161c.8019 1.8337 2.0789 4.1971 3.8667 5.9849zm5.1836 5.6991c-1.9323-.8449-4.5553-2.2423-6.5979-4.2849-2.0425-2.0425-3.4399-4.6655-4.2848-6.5978-.9168-2.0965-.2653-4.4084 1.261-5.9347l1.9632-1.9631 1.534.1448L11.3473 7.26l-.1198 1.2694-1.2198 1.2199c.1809.5804.6195 1.6143 1.6239 2.6187s2.0383 1.443 2.6187 1.6239l1.2199-1.2198 1.2694-.1199 5.0507 3.4346.1448 1.534-1.9631 1.9632c-1.5263 1.5263-3.8383 2.1778-5.9347 1.261z"
  })];
};

exports.default = _default;